import { Box, useStyles } from '@chakra-ui/react';
import React from 'react';

import IconButton from 'atoms/Button/IconButton';

type IconSizes = 'sm' | 'md' | 'lg';

type _TabListButtonRightProps = {
  onClick: () => void;
};

const _TabListButtonRight = (props: _TabListButtonRightProps): React.ReactElement => {
  const themeStyles = useStyles();
  const { onClick } = props;
  const size = themeStyles.tabListIconSize.boxSize as IconSizes;

  return (
    <Box __css={themeStyles.tabListIconRight}>
      <IconButton onClick={onClick} size={size} type="AngleRight" variant="ghost" />
    </Box>
  );
};

export default _TabListButtonRight;
